/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';

import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { getRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import { setHttpStatusCode } from 'src/shared/app/base/route/util/routeUtils';

const HTTPStatusCodeSwitch = (): React.Node => (
  <Switch>
    {getRoutes().map((route) => {
      // @TODO - really bad use of hook
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [path] = useRoutes(route);

      return (
        <Route
          path={path}
          exact
          render={(props) => {
            if (!path || path === '*') {
              setHttpStatusCode(props, 404);
            }

            return null;
          }}
          key={path}
        />
      );
    })}
  </Switch>
);

export default compose(React.memo)(HTTPStatusCodeSwitch);
